<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex sm3>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="productCode"
              label="Product Code"
              v-model="queryParams.productCode"
              type="text"
              class="ml-2"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="productName"
              label="Product Name"
              v-model="queryParams.productName"
              type="text"
              class="ml-2"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="issueNo"
              label="Issue No"
              v-model="queryParams.issueNo"
              type="text"
              class="ml-2"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="poNo"
              label="Po No"
              v-model="queryParams.poNo"
              type="text"
              class="ml-2"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 v-if="showShopFilter">
            <v-autocomplete
              label="Shop"
              :items="shopList"
              v-model="queryParams.shopId"
              item-text="name"
              item-value="id"
              color="blue-grey lighten-2"
              menu-props="auto"
              :hide-no-data="true"
              class="ml-2"
            ></v-autocomplete>
          </v-flex>
          <v-flex sm3 v-if="showStatusFilter">
            <v-select
              label="Status"
              :items="statusList"
              v-model="queryParams.status"
              item-text="label"
              item-value="value"
              class="ml-2"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex sm12 class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="productionOrderList"
              class="elevation-1"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td @click="dialogClose(props.item)">
                  <a>{{ props.item.issueNo }}</a>
                </td>
                <td>{{ props.item.issueDateInMilliSeconds | formatMsDate }}</td>
                <td>{{ props.item.poNo }}</td>
                <td>{{ props.item.shopName }}</td>
                <td>{{ props.item.warehouseName }}</td>
                <td>{{ props.item.fromDepartmentName }}</td>
                <td>{{ props.item.toDepartmentName }}</td>
                <td>{{ props.item.productName }}</td>
                <td>{{ props.item.qty }}</td>
                <td>{{ props.item.status }}</td>
                <td>
                  {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { productionOrderService } from "../../services/production-order-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "ProductionOrderDialog",
  props: {
    showDialog: Boolean,
    params: Object,
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      poNo: "",
      fromDepartmentId: "",
      toDepartmentId: "",
      productCode: "",
      productName: "",
      shopId: "",
      status: "DRAFT",
      warehouseId: "",
      binId: "",
      stockWarehouseId: "",
      stockBinId: "",
      productionType: "",
      isAddDetails: false,
      isAddUnits: false,
      checkLocationMovement: false,
    },
    headers: [
      { text: "Issue No", align: "left", value: "issueNo" },
      { text: "Issue Date", value: "issueDate" },
      { text: "Po No", align: "left", value: "poNo" },
      { text: "Shop", value: "shop.name" },
      { text: "Warehouse", value: "warehouse.name" },
      { text: "From Department", value: "fromDepartment.name" },
      { text: "To Department", value: "toDepartment.name" },
      { text: "Product Name", value: "productName" },
      { text: "Qty", value: "qty" },
      { text: "Status", value: "status" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    statusList: [
      { label: "---ALL---", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    totalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    shopList: [],
    productionOrderList: [],
    showShopFilter: true,
    showStatusFilter: true,
  }),
  created() {
    this.getShopList();
  },
  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getProductionOrderList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams = { ...this.params };
          if (this.params) {
            this.showShopFilter = this.params.showShopFilter;
            this.showStatusFilter = this.params.showStatusFilter;
          }
          this.productionOrderList = [];
          this.getProductionOrderList();
        }
      },
    },
  },
  methods: {
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductionOrderList();
    },
    getProductionOrderList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productionOrderService
        .getProductionOrderList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productionOrderList = res.data.productionOrderList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    dialogClose(productionOrder) {
      this.$emit("close", productionOrder);
    },
  },
};
</script>
